import axios from "@/api/axiosInstance";
import { FetchEmployeeProfileResponse } from "./types";

export const fetchEmployeeProfile = async (
  uuid: string,
): Promise<FetchEmployeeProfileResponse> => {
  const response = await axios.get<FetchEmployeeProfileResponse>(
    `/api/private/employee-directory/profiles/${uuid}`,
  );
  return response.data;
};
